/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vue Monica Refine Design
  Author: Riyan Kurniawan
  -- MONICA --
==========================================================================================*/

import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
import CanvasVideo from 'vue-canvasvideo'
import 'vue-canvasvideo/dist/vuecanvasvideo.min.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import vSelect from 'vue-select'
import './assets/css/custom.css'

import Multiselect from 'vue-multiselect'

Vue.component('multiselect', Multiselect)
Vue.component('v-select', vSelect)
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker)
// Vue.use(Vuesax);
Vue.use(Vuesax, {
  theme: {
    colors: {
      primary: '#CF4747',
      success: 'rgb(23, 201, 100)',
      danger: 'rgb(242, 19, 93)',
      warning: 'rgb(255, 130, 0)',
      dark: 'rgb(36, 33, 69)',
    },
  },
})

Vue.use(CanvasVideo)

import JsonExcel from 'vue-json-excel'

Vue.component('downloadExcel', JsonExcel)

// axios
import axios from 'axios'

// Match treffix-fe behaviour so relative API calls (e.g., /investigasi-area)
// hit the backend domain instead of the frontend host.
axios.defaults.baseURL = process.env.VUE_APP_URL_ENDPOINT

Vue.prototype.$http = axios

// Theme Configurations
import '../themeConfig.js'

// Algolia - Instant Search
import InstantSearch from 'vue-instantsearch'

Vue.use(InstantSearch)

// Firebase
import '@/firebase/firebaseConfig'

//toast
import Toast from 'vue-toastification'
// Import the CSS or use your own!
import 'vue-toastification/dist/index.css'

const options = {
  timeout: 2000,
  containerClassName: 'my-container-class',
  // You can set your default options here
}

Vue.use(Toast, options)

// Auth0 Plugin
import AuthPlugin from './plugins/auth'

Vue.use(AuthPlugin)

// Sera DATA
import LocalDataPlugin from './plugins/customSera'

Vue.use(LocalDataPlugin)

// ACL
// import acl from './acl/acl'

// Globally Registered Components
import './globalComponents.js'

// Styles: SCSS
import './assets/scss/main.scss'

// Tailwind
import '@/assets/css/main.css'

// import VueCrontab from 'vue-crontab'
// VueCrontab.setOption({
//     interval: 60000,
//     auto_start: false
// })
// Vue.use(VueCrontab);

// Vue Router
import router from './router'

// Vuex Store
import store from './store/store'

// i18n
import i18n from './i18n/i18n'

// Vuesax Admin Filters
import './filters/filters'

// Clipboard
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)

// Tour
import VueTour from 'vue-tour'

Vue.use(VueTour)
require('vue-tour/dist/vue-tour.css')

// VeeValidate
import VeeValidate from 'vee-validate'

Vue.use(VeeValidate)

// Google Maps
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    // Add your API key here
    key: process.env.VUE_APP_MAP_API,
    libraries: 'geometry,drawing,places', // This is required if you use the Auto complete plug-in
    v: '3.64',  // ← pin ke versi lama

  },
})

// Leaflet Maps
import { LMap, LTileLayer, LMarker, LPopup, LTooltip } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
// import 'leaflet.markercluster/dist/MarkerCluster.css'
require('./assets/css/leaflet.css')

Vue.component('l-map', LMap)
Vue.component('l-tile-layer', LTileLayer)
Vue.component('l-marker', LMarker)
Vue.component('l-popup', LPopup)
Vue.component('l-tooltip', LTooltip)

// global register at main.js
import VueCountdownTimer from 'vuejs-countdown-timer'
Vue.use(VueCountdownTimer)

import OtpInput from '@bachdgvn/vue-otp-input'
Vue.component('v-otp-input', OtpInput)

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

// Feather font icon
require('./assets/css/iconfont.css')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
